<template>
    <div class="library_filter_section">
        <input type="checkbox" id="category" class="library-filter-show-hide-input hidden">
        <label class="library-filter-label" for="category">Filter by type</label>
        <div class="library_filter_items">
            <div v-for="category in categories" :key="category.id" class="library_filter_item">
                <library-filter-button :item-id="category.slug" :item-value="category.id" :item-title="category.title | shorten" @updated="update"></library-filter-button>
            </div>
            <div class="library_filter_item flex_fix"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        categories: {
            required: true,
            type: Array,
        },
    },
    data() {
        return {
            checkedCategories: [],
        }
    },
    filters: {
        shorten(title) {
            return title.replace('And', '&');
        }
    },
    methods: {
        update(payload) {
            this.checkedCategories = this.checkedCategories.filter(el => el != payload.item);
            if (payload.active) { this.checkedCategories.push(payload.item); }
            this.$emit('categoriesChanged', this.checkedCategories);
        }
    }

}
</script>
